const INITIAL_STATE = {
  error: false,
  loading: false,
  data: [],
};

const AddCodes = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "CODES_ADD_REQUEST":
      return { loading: true, error: false, data: [] };
    case "CODES_ADD_ERROR":
      return { loading: false, error: true, data: [] };
    case "CODES_ADD_SUCCESS":
      return { loading: false, error: false, data: action.payload };
    case "CODES_ADD_RESET":
      return { loading: false, error: false, data: [] };
    default:
      return state;
  }
};

export default AddCodes;
